export function convertConsumerPuidToGuid(puid) {
    return '00000000-0000-0000-'.concat(puid.slice(0, 4), '-', puid.slice(4));
}
//# sourceMappingURL=convertConsumerPuidToGuid.js.map